import React from 'react';
import './FilePlayer.scss';

class FilePlayer extends React.Component{

  render(){
    return (
        <div className="FilePlayer">
          {}
        </div>
    );
  }

}

export default FilePlayer;
